import { useSignMessage as _useSignMessage, useAccount } from "wagmi"
import { SignMessageVariables } from "wagmi/query"
import { reservePopup, releaseReservedPopup } from "@privy-io/popup"
import { useIsPrivyCrossApp } from "./useIsPrivyCrossApp"

export const useSignMessage = () => {
  const { connector } = useAccount()
  const { signMessageAsync: _signMessageAsync } = _useSignMessage()
  const { isPrivyCrossApp } = useIsPrivyCrossApp()

  const signMessageAsync = async (args: SignMessageVariables) => {
    if (!connector) {
      throw new Error('Wallet not connected')
    }

    if (isPrivyCrossApp) {
      reservePopup()
    }

    try {
      const data = await _signMessageAsync(args)
      return data
    } catch (error) {
      throw error
    } finally {
      releaseReservedPopup()
    }
  }

  return { signMessageAsync }
}
